VariationsWidget = window.VariationsWidget ?= {}
Cart = window.Cart ?= {}

DealEventPipe = require '../../deal/frontend/event_pipe'
Cart.Helpers = require '../../cart/common/helpers'

class VariationsWidget.Controller
  constructor: ->
    @ie7 = true if OptimizeSuite?.TrackingHub.user.browser is 'IE' and OptimizeSuite.TrackingHub.user.browserVersion is '7.0'
    @i18n = I18n.scoped() if I18n?
    @updateSelectElements "", true
    @availableOptions = @getAvailableOptions()
    @cheapestOption = @getCheapestAvailableOption @availableOptions
    @lastImage = ""
    @clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection
    @$selectElements = $('#variation-traits').find('.variation-trait')
    if VariationsWidget.preSelectTraits?.length
      @makeSelectionsViaPreselection()
    else
      @updateSelectionsToDefault()

  render: (latestSelection, updateCarousel = true) ->
    if latestSelection.selection?
      @updateSelections latestSelection
      @updateSelectElements latestSelection.trait
      @availableOptions = @getAvailableOptions()
      @cheapestOption = @getCheapestAvailableOption @availableOptions
      @updatePricing @cheapestOption, @availableOptions.length
      if updateCarousel then @updateCarousel()
      @removeErrorMessages()
    return

  updateSelectionsToDefault: ->
    for selectElement in @$selectElements or []
      $(selectElement).find('option:eq(0)').prop('selected', true)

  updateSelections: (latestSelection) ->
    for collection in VariationsWidget.collections
      if collection.models[0].get('traitName') == latestSelection.trait
        collection.setSelected latestSelection.id
        break
    return

  updateSelectElements: (latestSelection, updateAll = false) ->
    if VariationsWidget.printOptionPrice then updateAll = true
    for collection in VariationsWidget.collections
      traitName = collection.models[0].get('traitName')

      # Don't update the most recent select that was just chosen, unless boolean specifies otherwise
      if traitName != latestSelection || updateAll
        conditions = @getConditions(collection.selected())
        lastSelection = (_.keys(conditions).length == VariationsWidget.collections.length - 1)

        enabledOptions = []
        unavailableOptions = []
        if not $.isEmptyObject conditions
          enabledOptions = _.where VariationsWidget.options, conditions
        else
          enabledOptions = VariationsWidget.options

        enabledValues = _.pluck enabledOptions, traitName

        unavailableValues = _.uniq enabledValues
        notSoldOut = []
        for option in enabledOptions
          for value in unavailableValues
            if value == option[traitName] and not option.isSoldOut
              notSoldOut.push value

        unavailableValues = _.difference unavailableValues, notSoldOut
        enabledValues.unshift "#{@i18n.t('js.modules.variations.selector')} #{traitName}"

        for trait in VariationsWidget.collections
          if trait.models[0].get('traitName') == traitName
            for model in trait.models
              @setOptionState( model, enabledValues, unavailableValues )

              #if all other collections have selections
              if lastSelection and !conditions[traitName]?
                @setOptionPrice( model, enabledValues, enabledOptions )
              else if !conditions[traitName]?
                @setOptionFromPrice( model, enabledValues, enabledOptions )
              else
                model.set('optionPrice', false)

    if @ie7
      $('option').removeClass "ie7-color"
      $('option[disabled]').addClass "ie7-color"

  setOptionState: (model, enabledValues, unavailableValues) ->
    printSoldOut = VariationsWidget.printSoldOut

    if model.id is 0 or (_.contains enabledValues, model.get('traitValue'))
      if model.get('isSoldOut') or (unavailableValues? and (_.contains unavailableValues, model.get('traitValue')))
        model.set('disabled', true)
        model.set('forceDisplay', true) if printSoldOut
      else
        model.set('disabled', false)
        model.set('forceDisplay', false) if printSoldOut
    else
      model.set('disabled', true)
      model.set('forceDisplay', false) if printSoldOut
    return

  setOptionFromPrice: (model, enabledValues, enabledOptions) ->
    printOptionPrice = VariationsWidget.printOptionPrice
    return unless printOptionPrice

    value = model.get('traitValue')
    name = model.get('traitName')
    selected = model.get('selected')
    modelID = model.get('id')
    traitOptions = _.filter( enabledOptions, ((item) -> item[name] is value) )

    if selected or modelID == 0
      return model.set('optionPrice', false)

    if (_.contains enabledValues, value)
      cheapestOption = @getCheapestAvailableOption(traitOptions)
      if cheapestOption?
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {minPrice: cheapestOption.newPrice}))
    return

  setOptionPrice: (model, enabledValues, enabledOptions) ->
    printOptionPrice = VariationsWidget.printOptionPrice
    return unless printOptionPrice

    value = model.get('traitValue')
    name = model.get('traitName')
    selected = model.get('selected')
    modelID = model.get('id')

    if selected or modelID == 0
      return model.set('optionPrice', false)

    if (_.contains enabledValues, value)
      for option in enabledOptions
        if value == option[name]
          model.set('optionPrice', option.newPrice)
    return

  getConditions: (selected) ->
    conditions = {}
    for tempCollection in VariationsWidget.collections
      tempSelected = tempCollection.selected()
      tempSelectedTraitValue = tempSelected.get('traitValue')
      if tempSelectedTraitValue != selected.get('traitValue') and not @isSelectionDefault tempSelectedTraitValue
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue
    conditions

  getAvailableOptions: ->
    properties = {}
    for collection in VariationsWidget.collections
      selectedTrait = collection.selected()
      selectedTraitValue = selectedTrait.get('traitValue')
      properties[selectedTrait.get('traitName')] = selectedTraitValue unless @isSelectionDefault selectedTraitValue
    if $.isEmptyObject properties
      options = VariationsWidget.options
    else
      options = _.where VariationsWidget.options, properties
    options

  getCheapestAvailableOption: (availableOptions) ->
    currentCheapest = undefined

    for option in availableOptions
      if !option.isSoldOut and (currentCheapest is undefined or (option.amount < currentCheapest.amount))
        currentCheapest = option

    return currentCheapest or availableOptions[0]

  overridePriceDataWithSaleInfo: (priceData, option) ->
    return unless option?.regularPrice? or VariationsWidget.offerCollections?.offerOptions?

    sale = {}
    if option.regularPrice
      # urgency pricing
      _.extend sale,
          urgencyPricing:
            regularPrice: option.regularPrice
            newPrice: option.newPrice
            pricingMetadata: option.pricingMetadata

    for offer in VariationsWidget.offerCollections?.offerOptions or []
      if offer.uuid is option.uuid
        priceData.buyUrl = offer.buyUrl if offer?.buyUrl? and not VariationsWidget.offerCollections?.offerModal?.isSoldOut
        _.extend sale, {offer}
    _.extend priceData, {sale} if sale isnt {}

  updatePricing: (cheapestOption, length) ->
    priceData =
      value: cheapestOption.oldPrice
      percent: cheapestOption.discount
      savings: cheapestOption.savePrice
      price: cheapestOption.newPrice
      lengthClass: cheapestOption.lengthClass
      buyUrl: @buyButtonUrl cheapestOption
      uuid: cheapestOption.uuid
      variationsSelected: length is 1 and not @areAnySelectionsDefault VariationsWidget.collections
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount

    @overridePriceDataWithSaleInfo(priceData, cheapestOption)

    DealEventPipe.trigger "priceUpdate", priceData

  buyButtonUrl: (cheapestOption) ->
    return cheapestOption.externalUrl if cheapestOption.externalUrl?.length

    if payload?.cartStatus
      Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid)
    else
      cheapestOption.url

  updateCarousel: ->
    if @areSelectionsDefault VariationsWidget.collections
      DealCarousel.carouselViews[payload.carousel.dealId].updateGallery DealCarousel.dealMedia[payload.carousel.dealId].models[0]
    else
      for imageUrl, valuesHash of VariationsWidget.mappings
        foundMatch = _.every VariationsWidget.collections, (collection) =>
          selectedTrait = collection.selected()
          selectedTraitValue = selectedTrait.get('traitValue')
          if @isSelectionDefault selectedTraitValue
            return true
          else _.contains valuesHash[selectedTrait.get('traitName')], selectedTraitValue
        currentImage = DealCarousel.carouselViews[payload.carousel.dealId].currentFeatured.baseURL
        if foundMatch && currentImage != imageUrl
          @changeToMatchingImage imageUrl
          break
    return

  changeToMatchingImage: (imgPath) ->
    @lastImage = imgPath
    image = DealCarousel.dealMedia[payload.carousel.dealId].findWhere
      thumb: "#{imgPath}t100x100#{payload.carousel.imageQuality}.jpg"
    DealCarousel.carouselViews[payload.carousel.dealId].updateGallery image

  findMatchingTraits: (img) ->
    @lastImage = img
    selections = []
    if VariationsWidget.mappings[img]?
      for key, value of VariationsWidget.mappings[img]
        if value.length == 1 then selections.push
          trait: key
          selection: value[0]
    @makeSelectionsViaCarousel selections

  makeSelectionsViaCarousel: (selections) ->
    return if selections?.length < 1 and !@clearTraitsOnCarouselSelection
    @clearSelections()
    @makeSelections selections

  makeSelectionsViaPreselection: ->
    option = _.findWhere VariationsWidget.options, uuid: VariationsWidget.dealOptionUuid
    return if !option? or option.isSoldOut
    selections = []
    for trait in VariationsWidget.preSelectTraits or []
      for collection in VariationsWidget.collections or []
        if collection.models[0].get("traitName") is trait
          selections.push
            trait: trait
            selection: option[trait]
          break
    @makeSelections selections

  clearSelections: ->
    for collection in VariationsWidget.collections or []
      selectedTrait = collection.selected()
      selectedTraitName = selectedTrait.get('traitName')
      if not @isSelectionDefault selectedTrait.get('traitValue')
        selection = @i18n.t('js.modules.variations.select', name: selectedTraitName)
        data =
          trait: selectedTraitName
          selection: selection
          id: 0
        $("#trait-#{selectedTrait.get('traitIndex')}").val(selection)
        unless $("#trait-#{selectedTrait.get('traitIndex')}").val()?
          $("#trait-#{selectedTrait.get('traitIndex')}").prop('selectedIndex', 0)
        @render data, false

  makeSelections: (selections) ->
    for element in selections or []
      for collection in VariationsWidget.collections or []
        if collection.models[0].get('traitName') == element.trait
          trait = collection.findWhere
            traitValue: element.selection
          if !trait.get('disabled')
            element['id'] = trait.get('id')
            $('#trait-'+collection.models[0].get('traitIndex')).val(element.selection)
            @render element, false
            break
    return

  showErrorMessages: ->
    VariationsWidget.error.show()
    VariationsWidget.error.$el.addClass "icon-circle-alert"
    defaultCollections = @findDefaultCollections VariationsWidget.collections
    for index in defaultCollections
      $('#trait-'+index).addClass 'error'

  removeErrorMessages: ->
    VariationsWidget.error.hide() unless @areAnySelectionsDefault VariationsWidget.collections
    selectedCollections = @findSelectedCollections VariationsWidget.collections
    for index in selectedCollections
      $('#trait-'+index).removeClass 'error'

  areSelectionsDefault: (collections) ->
    _.every collections, (collection) =>
      RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue'))

  areAnySelectionsDefault: (collections) ->
    _.some collections, (collection) =>
      RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue'))

  isSelectionDefault: (selection) =>
    RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(selection)

  findDefaultCollections: (collections) =>
    defaultCollections = []
    for collection, index in collections
      if RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue')) then defaultCollections.push index
    defaultCollections

  findSelectedCollections: (collections) =>
    selectedCollections = []
    for collection, index in collections
      if not RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue')) then selectedCollections.push index
    selectedCollections


module.exports = VariationsWidget.Controller
